export default {
  setSitemaps(state, payload) {
    state.sitemaps = payload;
  },
};
